import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { INCOME_VERIFICATION_PROVIDER_FINICITY } from 'common/incomeVerificationConstants';

import {
  SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING,
  SR_API_ACTION_INCOME_VERIFICATION_GET_SCREENING_URL,
} from 'api/actionTypes';

import withJsScript from 'client/helpers/withJsScript';
import withLocationQuery from 'client/helpers/withLocationQuery';
import branch from 'client/core/branch';
import postWithState from 'client/actions/postWithState';
import log from 'client/lib/log';

import SrBox from 'client/components/SrBox';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_YELLOW,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

@branch()
@withJsScript({
  preventRender: true,
  scriptUrl: 'https://connect2.finicity.com/assets/sdk/finicity-connect.min.js',
})
@withLocationQuery
class SrFinicityProofOfConceptPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Finicity POC | Sunroom Rentals',
  });

  static propTypes = {
    locationQuery: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      iframeUrl: null,
    };
  }

  _onStartIncomeVerificationClick = async () => {
    const { locationQuery, dispatch } = this.props;

    const incomeVerificationUserId = parseInt(locationQuery.userId || 209521, 10);
    const incomeVerificationListingId = parseInt(locationQuery.listingId || 431123, 10);

    const incomeVerificationGroup = await dispatch(postWithState, {
      action: SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING,
      payload: {
        userIds: [incomeVerificationUserId],
        listingId: incomeVerificationListingId,
        provider: INCOME_VERIFICATION_PROVIDER_FINICITY,
      },
    });

    const incomeVerification = incomeVerificationGroup.incomeVerifications.find(({ userId }) => {
      return userId === incomeVerificationUserId;
    });

    if (incomeVerification) {
      const screeningUrl = await dispatch(postWithState, {
        action: SR_API_ACTION_INCOME_VERIFICATION_GET_SCREENING_URL,
        payload: {
          incomeVerificationId: incomeVerification.id,
        },
      });

      if (screeningUrl) {
        this.setState({
          iframeUrl: screeningUrl,
        });

        if (global.finicityConnect) {
          global.finicityConnect.launch(screeningUrl, {
            selector: '#finicity-iframe',
            overlay: 'rgba(199,201,199, 0.5)',
            success: (event) => {
              log.info('Yay! User went through Connect', event);
              this._onIncomeVerificationCompleted();
            },
            cancel: (event) => {
              log.info('cancel', event);
              this._onCloseIncomeVerificationModal();
            },
            error: (error) => {
              log.error(error);
            },
            loaded: () => {
              log.info('This gets called only once after the iframe has finished loading ');
            },
            route: (event) => {
              log.info('This is called as the user navigates through Connect ', event);
            },
            user: (event) => {
              log.info('This is called as the user interacts with Connect ', event);
            },
          });
        }
      }
    }
  };

  _onCloseIncomeVerificationModal = () => {
    if (global.finicityConnect) {
      global.finicityConnect.destroy();
    }
    this.setState({
      iframeUrl: null,
    });
  };

  _onIncomeVerificationCompleted = () => {
    this._onCloseIncomeVerificationModal();
    setTimeout(() => {
      global.alert('Income verification completed.');
    }, 500);
  };

  render() {
    const { iframeUrl } = this.state;

    return (
      <SrBox>
        {!iframeUrl && (
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_YELLOW}
            onClick={this._onStartIncomeVerificationClick}
          >
            Start Income Verification
          </SrButton>
        )}
        <div id="finicity-iframe" />
        {iframeUrl && (
          <SrBox position="relative">
            <SrBox position="absolute" top="100px" left="100px">
              <SrButton
                theme={SR_BUTTON_THEME_ADOBE_GREEN}
                onClick={this._onCloseIncomeVerificationModal}
              >
                Back to SR
              </SrButton>
            </SrBox>
          </SrBox>
        )}
      </SrBox>
    );
  }
}

SrFinicityProofOfConceptPage.displayName = 'SrFinicityProofOfConceptPage';

export default SrFinicityProofOfConceptPage;
